// extracted by mini-css-extract-plugin
export default {"content":"wI-z","lookName":"xI-z","shopTheLookContainer":"yI-z","productContainer":"zI-z","imageContainer":"AI-z","mainImage":"BI-z"};